var data = {
  "body": "<path d=\"M13.281 6.781l-8.5 8.5l-.687.719l.687.719l8.5 8.5l1.438-1.438L7.938 17H28v-2H7.937l6.782-6.781z\" fill=\"currentColor\"/>",
  "width": 32,
  "height": 32
};
export default data;